<template>
  <div class="fee-management-wrapper py-4">
     <PageTitleBar
      parent="Institute Dashboard"
      title="Fee Management"
      icon="fas fa-coins fa-2x mb-2 text-warning"
    />
    <b-container fluid>

      <DashboardModal id="feeConfigModal" parent="Institute Dashboard › Fee Management" title="Configuration Settings"
        icon="fas fa-cogs fa-2x mb-2 text-primary" @close="closeConfig">
        <FeeConfig lazy />
      </DashboardModal>

      <DashboardModal id="studentMappingModal" parent="Institute Dashboard › Fee Management"
        title="Student Category Mapping / Generate Ledger" icon="fas fa-users-cog fa-2x mb-2 text-success"
        @close="closeStudentMapping">
        <StudentCategoryMapping lazy />
      </DashboardModal>

      <DashboardModal id="viewLedgerModal" title="View Ledger" parent="Institute Dashboard › Fee Management"
        icon="fas fa-file-invoice-dollar fa-2x mb-2 text-warning" @close="closeViewLedger">
        <ViewLedger lazy />
      </DashboardModal>

      <DashboardModal id="feeCollectionModal" title="Collect Fee" parent="Institute Dashboard › Fee Management"
        icon="fas fa-hand-holding-usd fa-2x mb-2 text-danger" @close="closeFeeCollection">
        <FeeCollection lazy />
      </DashboardModal>

      <!-- ================= DEFAULT DASHBOARD CARDS ================= -->
      <b-row>
        <b-col v-for="card in cards" :key="card.title" cols="12" md="6" lg="3" class="mb-4">
          <b-card class="text-center fee-card h-100" @click="card.action" no-body>
            <div class="py-4 d-flex flex-column align-items-center">
              <i :class="card.icon + ' fa-3x mb-3 ' + card.color"></i>
              <h5 class="card-title mb-0">{{ card.title }}</h5>
            </div>
          </b-card>
        </b-col>
      </b-row>


    </b-container>
  </div>
</template>

<script>
import PageTitleBar from '@/components/templates/Dashboard/Institute/PageTitleBar.vue';
import FeeConfig from './configurationSettings.vue';
import StudentCategoryMapping from './studentCategoryMapping.vue';
import ViewLedger from '../fee_management/ViewLedger.vue';
import FeeCollection from '../fee_management/feeCollection.vue';
import DashboardModal from "@/components/templates/Dashboard/Institute/DashboardModal.vue"

export default {
  name: "feeManagementDashboard",

  components: {
    DashboardModal,
    FeeConfig,
    StudentCategoryMapping,
    ViewLedger,
    FeeCollection,
    PageTitleBar
  },

  data() {
    return {
      cards: [
        {
          title: "Configuration Settings",
          icon: "fas fa-cogs",
          color: "text-primary",
          action: () => this.openConfig(),
        },
        {
          title: "Student Category Mapping / Generate Ledger",
          icon: "fas fa-users-cog",
          color: "text-success",
          action: () => this.openStudentMapping(),
        },
        {
          title: "View Ledger",
          icon: "fas fa-file-invoice-dollar",
          color: "text-warning",
          action: () => this.openViewLedger(),
        },
        {
          title: "Collect Fee",
          icon: "fas fa-hand-holding-usd",
          color: "text-danger",
          action: () => this.openFeeCollection(),
        },
      ],
    };
  },

  methods: {
    /* CONFIG */
    openConfig() { this.$bvModal.show("feeConfigModal"); },
    closeConfig() { this.$bvModal.hide("feeConfigModal"); },

    /* STUDENT CATEGORY MAPPING */
    openStudentMapping() { this.$bvModal.show("studentMappingModal"); },
    closeStudentMapping() { this.$bvModal.hide("studentMappingModal"); },

    /* VIEW LEDGER */
    openViewLedger() { this.$bvModal.show("viewLedgerModal"); },
    closeViewLedger() { this.$bvModal.hide("viewLedgerModal"); },

    /* FEE COLLECTION */
    openFeeCollection() { this.$bvModal.show("feeCollectionModal"); },
    closeFeeCollection() { this.$bvModal.hide("feeCollectionModal"); },
  },
};
</script>

<style scoped>
.usersListPendingFull .modal-dialog {
  max-width: 100%;
  max-height: 100vh;
  margin: 0;
  padding: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  position: fixed !important;
  z-index: 100000;
}

.usersListPendingFull .modal-content {
  border-radius: 0 !important;
  height: 100vh;
  width: 100vw;
}

.usersListPendingFull .modal-body {
  overflow-y: auto;
  height: calc(100vh - 60px);
  /* header height */
}

.fee-management-wrapper {
  background: #f9f9fb;
  min-height: 100vh;
  padding-top: 1rem;
}

.fee-card {
  border-radius: 16px;
  border: none;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  background: white;
  cursor: pointer;
}

.fee-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
}

.card-title {
  font-weight: 600;
  font-size: 1rem;
  transition: color 0.3s ease, text-decoration 0.3s ease;
}

.fee-card:hover .card-title {
  color: #0d6efd;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .text-right {
    text-align: center !important;
    margin-top: 1rem;
  }
}
</style>
